import { AdminApi } from 'stylemix-vue-admin'

export default class CompaniesApi extends AdminApi {
  constructor(parameters) {
    super('companies', parameters)
  }

  sendCompanyMail(companyId, data, config = {}) {
    return this.submit(
      'post',
      `/${this.endpoint}/${companyId}/sendmail`,
      data,
      config,
    )
  }

  sendMail(email, data, type = 'user', config = {}) {
    return this.submit(
      'post',
      `/users/sendmail/?email=${email}&type=${type}`,
      data,
      config,
    )
  }

  unsuspend(companyId) {
    return this.submit('post', `/${this.endpoint}/${companyId}/unsuspend`)
  }
}
